import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { Subscription } from '@core/api';
import { SharedButtonsModule } from '@shared/buttons';
import { SharedDialogsModule } from '@shared/dialogs';

import { getUpgradeDialogConfig, UpgradeDialogConfig } from '../../constants/upgrade-dialog.const';

export interface UpgradeDialogData {
  targetTier: Subscription;
  canUpgrade: boolean;
}

@Component({
  selector: 'la-upgrade-dialog',
  imports: [MatDialogModule, MatIconModule, SharedButtonsModule, SharedDialogsModule],
  templateUrl: './upgrade-dialog.component.html',
  styleUrl: './upgrade-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeDialogComponent {
  private readonly data = inject<UpgradeDialogData | null>(MAT_DIALOG_DATA, { optional: true });
  private readonly dialogRef = inject<MatDialogRef<UpgradeDialogComponent> | null>(MatDialogRef, { optional: true });
  private readonly router = inject(Router);

  get config(): UpgradeDialogConfig {
    return getUpgradeDialogConfig(this.data?.targetTier ?? Subscription.STANDARD, this.data?.canUpgrade ?? true);
  }

  onUpgrade() {
    const routeSuffix = this.data?.targetTier === Subscription.PROFESSIONAL ? 'change' : 'upgrade';
    this.router.navigate(['/account/subscription', routeSuffix]);

    this.dialogRef?.close(true);
  }
}
